import React from "react"

import { Toaster } from "@/components/ui/sonner"

export function wrapInertiaApp(app: React.ReactElement) {
  return (
    <>
      <Toaster position="top-right" richColors />
      {app}
    </>
  )
}
